import axios from 'axios'
import route from '../ziggy/route'

export default {
    setShippingMode(data) {
        return axios.post(route('shop.api.checkout.shippingMode.store').url(), data)
    },

    setPaymentMode(id) {
        return axios.post(route('shop.api.checkout.paymentMode.store').url(), { 'payment_mode': id })
    },

    setGuestCustomerData(data) {
        return axios.post(route('shop.api.checkout.guestCustomerData.store').url(), data)
    },

    setAuthenticatedCustomerData(data) {
        return axios.post(route('shop.api.checkout.authenticatedCustomerData.store').url(), data)
    },

    summary() {
        return axios.get(route('shop.api.checkout.summary').url())
    },

    checkoutData() {
        return axios.get(route('shop.api.checkout.data').url())
    },

    login(email, password) {
        return axios.post(route('shop.api.login').url(), {
            email, password
        })
    }
}
